import request from '@/router/axios';
export const add = (row) => {
    return request({
        url: '/api/produce/stock-management/insert',
        method: 'post',
        data: row
    })
}
export const update = (row) => {
    return request({
        url: '/api/produce/stock-management/update',
        method: 'post',
        data: row
    })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/stock-management/select/id',
        method: 'get',
        params: {
            id
        }
    })
}
export const getList = (params) => {
    return request({
        url: '/api/produce/stock-management/select/page',
        method: 'get',
        params
    })
}
export const remove = (ids) => {
    return request({
        url: '/api/produce/stock-management/delete/ids',
        method: 'get',
        params: {
            ids
        }
    })
}

export const getDailyStockStatistics = (row) => {
    return request({
        url: '/api/produce/stock-management/getDailyStockStatistics',
        method: 'post',
        data: row
    })
}

